module.exports = __webpack_public_path__ + "img/plot-app.e27bf81.png";